export const EXPERIENCE_OPTIONS = ['1-3 years', '4-7 years', '8-15 years', '15+ years']

export const DEGREE_LEVELS = ['S1', 'S2', 'S3']
